import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const ProfilesCtx = createContext({
  profiles: [],
  activeProfileId: "",
  setActiveProfileId: () => {},
  refresh: () => {},
});

const STORAGE_KEY = "ledger.activeProfileId";

export const ProfilesProvider = ({ children }) => {
  const { user } = useAuth();
  const [profiles, setProfiles] = useState([]);
  const [activeProfileId, _setActive] = useState(() => localStorage.getItem(STORAGE_KEY) || "");

  const refresh = useCallback(async () => {
    if (!user || (user.role !== "admin" && !user.is_approved)) { setProfiles([]); return; }
    try {
      const { data } = await api.get("/profiles");
      setProfiles(data);
      if (data.length && !data.find((p) => p.id === activeProfileId)) {
        const id = data[0].id;
        _setActive(id);
        localStorage.setItem(STORAGE_KEY, id);
      }
    } catch {
      setProfiles([]);
    }
  }, [user, activeProfileId]);

  useEffect(() => { refresh(); }, [user]); // eslint-disable-line

  const setActiveProfileId = (id) => {
    _setActive(id);
    localStorage.setItem(STORAGE_KEY, id);
  };

  return (
    <ProfilesCtx.Provider value={{ profiles, activeProfileId, setActiveProfileId, refresh }}>
      {children}
    </ProfilesCtx.Provider>
  );
};

export const useProfiles = () => useContext(ProfilesCtx);
